<div class="vfb-body">
</div>
<div class="vfb-side-panel">
  <div class="form-builder-side-panel" data-behaviour="form-builder-fields-container">
    <div id="form-content-tab" class="form-content-tab" data-behaviour="form-builder-fields">
    </div>
  </div>

  <div data-behaviour="form-builder-field-editor"></div>
</div>
